$(document).ready(function () {

  
if (window.matchMedia("(max-width: 882px)").matches) {
    $(".collection .product-grid.contains-card--product").slick({
      responsive: [
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            nextArrow: '<div class="slick_next-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Right_Arrow_icn.svg?v=1718175956" height="27px" width="18px"></div>',
            prevArrow: '<div class="slick_prev-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Left_Arrow_icn_copy.svg?v=1718175956" height="27px" width="18px"></div>'
          },
        },
      ],
    });
    $("#product-grid").slick({
      responsive: [
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            nextArrow: '<div class="slick_next-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Right_Arrow_icn.svg?v=1718175956" height="27px" width="18px"></div>',
            prevArrow: '<div class="slick_prev-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Left_Arrow_icn_copy.svg?v=1718175956" height="27px" width="18px"></div>'
          },
        },
      ],
    });
  }
  
  // Home page Logo Slider
  if (window.matchMedia("(max-width: 749px)").matches) {
    $(".index .multicolumn-list").slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 2400,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      infinite: true,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    var indexToGet = $('.image-redirects .instagram__image').index( $('.center_on_me'));
    $(".image-redirects").slick({
      dots: false,
      arrows: false,
      infinite: true,
      initialSlide: indexToGet,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      // variableWidth: true,
      centerPadding: "100px",
    });
  }

  // Find US Slider
  $(".find-us-template .multicolumn-list").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
    autoplaySpeed: 2100,
      autoplay: true,
      cssEase: "linear",
      infinite: true,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

  // Klaviyo Image Banner
 //  document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
	// 	window._klOnsite = window._klOnsite || []; 
	// 	window._klOnsite.push(['openForm', 'WhxGZE']);
	// });

  $(".story-slider_slide_wrap").slick({
    dots:true,
    infinite:false,
    nextArrow: '<div class="slick_next-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/right.svg?v=1718800293" height="27px" width="18px"></div>',
    prevArrow: '<div class="slick_prev-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/left.svg?v=1718800294" width="18px"></div>',
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100
  });

  // On before slide change
// $('.story-slider_slide_wrap').on('afterChange', function(event, slick, currentSlide, nextSlide){
//    $('.animImage').fadeOut();
//   $('.slick-current.slick-active .animImage').fadeIn();
// });
  
  //Product page Scroll
  // var $pageContent = $(".page-width");
  // var $customProductPage = $(".custom-product-page");
  // var hasScrolledBackground = false;
  // var scrollThreshold = 300; // Adjust the threshold as needed
  // var initialOffset = -90; // Initial offset of -90px

  // // Set initial background position with the offset
  // $customProductPage.css("transform", "translateY(" + initialOffset + "px)");

  // $(window).on("scroll", function () {
  //   var scrollY = $(this).scrollTop();
  //   var effectiveScrollY = initialOffset - scrollY; // Add initial offset to the scroll value
  //   console.log(scrollY , effectiveScrollY , "scrool" )    
  //   // Check if the background has scrolled sufficiently
  //   if (scrollY > scrollThreshold && !hasScrolledBackground) {
  //     $pageContent.css("opacity", 1); // Show content
  //     hasScrolledBackground = true;
  //   }

  //   // Translate the background image based on scroll
  //   $customProductPage.css(
  //     "transform",
  //     "translateY(" + effectiveScrollY + "px)"
  //   );
  // });
 

  const mediaQuery = window.matchMedia("(max-width: 479px)");
  if (mediaQuery.matches) {
    $(
      ".footer__blocks-wrapper > .footer-block--menu > .footer-block__details-content"
    ).hide();
    $(".footer__blocks-wrapper > .footer-block--menu .footer-block__heading").click(function () {
      if ($(this).parent().hasClass("active")) {
        $(this).parent()
          .removeClass("active")
          .find(".footer-block__details-content")
          .slideUp();
      } else {
        $(
          ".footer__blocks-wrapper > .footer-block--menu.active .footer-block__details-content"
        ).slideUp();
        $(".footer__blocks-wrapper > .footer-block--menu.active").removeClass(
          "active"
        );
        $(this).parent()
          .addClass("active")
          .find(".footer-block__details-content")
          .slideDown();
      }
      return false;
    });
  }

  $(".mid-cen-inner").hide();
    $(".toggle_mid-cen-main").click(function () {
      if ($(this).hasClass("active")) {
        $(this)
          .removeClass("active")
          .find(".mid-cen-inner")
          .slideUp();
      } else {
        $(
          ".mid-cen-inner"
        ).slideUp();
        $(".mid-cen-inner").removeClass(
          "active"
        );
        $(this)
          .addClass("active")
          .find(".mid-cen-inner")
          .slideDown();
      }
      return false;
    });

function slickslidergrid(){
 setTimeout(function(){
  if (window.matchMedia("(max-width: 882px)").matches) {
        $("#product-grid").slick({
      responsive: [
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            nextArrow: '<div class="slick_next-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Right_Arrow_icn.svg?v=1718175956" height="27px" width="18px"></div>',
            prevArrow: '<div class="slick_prev-btn"><img src="https://cdn.shopify.com/s/files/1/0441/7844/0344/files/Left_Arrow_icn_copy.svg?v=1718175956" height="27px" width="18px"></div>'
          },
        },
      ],
    });
  }
  },2000); 
}


  
$(".tab_main-collection").click(function(e){
  $(".tab_main-collection").removeClass('active_collection-tab');
  $(this).addClass('active_collection-tab');
  e.preventDefault();
  var redirectLink = $(this).attr('href');
  console.log(redirectLink , "redirectLink");
  // $('#product-grid-container').load('/' + redirectLink);
  
    $("#ProductGridContainer").load('/collections/'  + redirectLink +" #ProductGridContainer");
    window.history.pushState("object or string", "Title", '/collections/' + redirectLink );
    slickslidergrid();
});

  
// $("#SortBy-mobile").on('change', () => {
//   slickslidergrid();
// });
// $(".mobile-facets__submenu label").click(function(){
//   slickslidergrid();
// });
// if ($("body").hasClass("404")){
//   window.location.href = "/collections/flavors?view=flavors-collection";
// }


  $('.search .template-search__results').slick('unslick');

});

// movie slider
$(".movie").slick({
  dots:true,
  infinite:false,
  arrows:false,
  initialSlide: 0,
  slidesToScroll: 1,
  slidesToShow: 1,
    fade: true,
  cssEase: 'linear',
  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
});


// $('.movie').on('init', function(event, slick){

//   console.log("init");
//   $('.movie .movie__item--content')[0].fadeIn();
// });

$('.movie').on('beforeChange', function(event, slick, currentSlide, nextSlide){

  console.log("beforechange");
    $('.movie__item--content').css('opacity', '0');
  $('.movie__item--content').removeClass('animate__animated animate__fadeInUp');
  // $('.movie__item--image').removeClass('animate__animated animate__zoomIn');
});


$('.movie').on('afterChange', function(event, slick, currentSlide, nextSlide){

  console.log("afterchange");
  $('.movie__item--content').addClass('animate__animated animate__fadeInUp');
  // $('.movie__item--image').addClass('animate__animated animate__zoomIn');
});